





































import { defineComponent, onMounted, PropType } from "@vue/composition-api"
import { useActions, useGetters } from "vuex-composition-helpers"
import ExchangeFilter from "@/apps/StudentExchangeOverviewWidget/components/molecules/ExchangeFilter.vue"
import InnerLoader from "@/shared/components/atoms/InnerLoader.vue"
import Studies from "@/apps/StudentExchangeOverviewWidget/components/Studies.vue"
import { ILabels, ILanguage } from "@/apps/StudentExchangeOverviewWidget/models/config-viewmodel"
import { IInformationSectionEvent } from "@/apps/StudentExchangeOverviewWidget/models/information-section-viewmodel"

export default defineComponent({
    name: "StudentExchangeOverviewWidget",
    components: {
        Studies,
        InnerLoader,
        ExchangeFilter
    },
    props: {
        labels: {
            type: Object as PropType<ILabels>,
            required: true
        },
        language: {
            type: String as PropType<ILanguage>,
            required: true
        }
    },
    setup: (props: { labels: ILanguage, language: ILabels }) => {
        const { setLabels, setLanguage, loadStudentExchangeOverview, setModalOpen, setOffset } = useActions([
            'setLabels',
            'setLanguage',
            'loadStudentExchangeOverview',
            'setModalOpen',
            'setOffset'
        ])
        setLabels(props.labels)
        setLanguage(props.language)
        const { getLoading, getLabels, getModalOpen, getOffset } = useGetters([
            'getLoading',
            'getLabels',
            'getModalOpen',
            'getOffset'
        ])

        onMounted(async () => {
            window.document.addEventListener('informationModalEvent', (event) => {
                const customEvent = event as CustomEvent<IInformationSectionEvent>
                
                setOffset(customEvent.detail.offset);
                setModalOpen(true);
                document.body.style.position = 'fixed';
            })

            await loadStudentExchangeOverview();
        })

        function onClose() {
            setModalOpen(false);

            document.body.style.position = '';
            document.documentElement.scrollTop = document.body.scrollTop = getOffset.value;
        }

        return {
            getLoading,
            getLabels,
            getModalOpen,
            getOffset,
            onClose
        }
    }
})
